import { METADATA, METADATA_BY_KEY } from "@/content/data";
import type { Key, KeyList, Metadata } from "@/content/types";

export function getMetadata(key: Key): Metadata {
  return METADATA_BY_KEY[key];
}

type GetMetadatasOptions = {
  limit?: number;
};

export function getMetadatas(
  keys?: KeyList,
  options?: GetMetadatasOptions,
): Metadata[] {
  if (!keys) {
    return METADATA.slice(0, options?.limit);
  }

  const list = Array.isArray(keys) ? keys : [keys];

  return list
    .map(key => METADATA_BY_KEY[key])
    .filter(Boolean)
    .slice(0, options?.limit);
}
